import {
  Checkbox,
  FormControlLabel,
  Typography,
} from '@mui/material'
import {
  useState,
  useEffect,
  useContext,
  SyntheticEvent,
} from 'react'
import { useSelector } from '@xstate/react'
import { LmnContext } from 'src/components/Dialogs/Lmn/LmnDialog'
import { getCustomerInfo } from 'src/helpers/lmnHelpers'

interface CheckboxProps {
  condition: string
  handleCheckboxChanged: (value: boolean, condition: string) => void
}
const LmnPreliminaryAssessmentCheckbox = ({
  condition,
  handleCheckboxChanged,
}: CheckboxProps): JSX.Element => {
  const { lmnContextService } = useContext(LmnContext)
  const { diagnosis } = useSelector(lmnContextService, getCustomerInfo)
  const [checked, setChecked] = useState(false)

  const handleOnChange = (value: boolean): void => {
    setChecked(value)
    handleCheckboxChanged(value, condition)
  }

  useEffect(() => {
    // Repopulating checkbox value if they go back to this screen
    if (diagnosis !== '') {
      const conditions = diagnosis.split('*')
      const isSelected = conditions.find((value) => value === condition)

      if (isSelected) {
        setChecked(!!isSelected)
      }
    }
    // only running this once on component load w/ empty array
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [])

  return (
    <FormControlLabel
      sx={{ marginRight: '0px !important', marginBottom: '0px !important' }}
      control={(
        <Checkbox
          size="small"
          checked={checked}
          onChange={(
            _event: SyntheticEvent<Element, Event>,
            value: boolean,
          ) => handleOnChange(value)}
        />
      )}
      label={<Typography variant="body3">{condition}</Typography>}
    />
  )
}

export default LmnPreliminaryAssessmentCheckbox
